import styled from 'styled-components';

const Dropdown = styled.div`
  background-color: white;
  position: absolute;
  margin: 8px 0;
  width: auto;
  height: 120px;
  overflow-y: scroll;
  padding: 16px 0;
  border-radius: 12px;
  box-shadow: 4px 5px 10px #ccc;
  z-index: 1000;
`;

export default Dropdown;
